import React from "react";
import { Input } from "antd";

const { TextArea } = Input;

const UITextArea = ({
  placeholder = "",
  value = "",
  onchange = { onchange },
  rows,
  minRows,
}) => {
  return (
    <TextArea
      rows={rows}
      placeholder={placeholder}
      minLength={10}
      autoSize={{ minRows: minRows ? minRows : 8 }}
      value={value}
      onChange={(e) => {
        onchange(e.target.value);
      }}
    />
  );
};

export default UITextArea;
